import React, { useState, useEffect , useRef} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Heart, HeartFill, Cart, Lightning, StarFill, StarHalf, Star, PlayCircleFill } from 'react-bootstrap-icons';
import { useAuth } from "../../context/authContext";
import PurchaseModal from '../purchaseModal/PurchaseModal';
import { checkAuth } from '../../utils/auth';
const API = process.env.REACT_APP_API_URL;

const ProductDetailsPage = () => {
  const { id,domain } = useParams();
  const selectedDomain = domain
  const navigate = useNavigate();
  const [activeMedia, setActiveMedia] = useState(null); // State for currently selected image/video
  const [product, setProduct] = useState(null); const [mediaList, setMediaList] = useState([]);
  const { user } = useAuth()
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
  const [buyNowItems, setBuyNowItems] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [buyNowQuantity, setBuyNowQuantity] = useState(1);
  const [isCustomQuantity, setIsCustomQuantity] = useState(false);
  const [customInput, setCustomInput] = useState('4');
  const {
    products,
    setCart,
    wishlist,
    fetchWishlist,
    handleAddToWishlist,
    handleRemoveFromWishlist,
    handleBuyNow,
    isLoggedIn
  } = useAuth();
  const [loadingProduct, setLoadingProduct] = useState(true);

  
  const imageRef = useRef(null);
const lensRef = useRef(null);
const zoomRef = useRef(null);

const [showZoom, setShowZoom] = useState(false);
 useEffect(() => {
  const fetchProduct = async () => {
    setLoadingProduct(true);
    try {
      const res = await fetch(`${API}/api/products/${selectedDomain}/${id}`);
      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      setProduct(data);

      const media = (data.media || []).map(m => ({
        type: m.type || 'image',
        src: m.url.startsWith("http") ? m.url : `${API}${m.url}`
      }));

      if (media.length === 0 && data.image_url) {
        media.push({
          type: 'image',
          src: data.image_url.startsWith("http") ? data.image_url : `${API}${data.image_url}`
        });
      }

      setMediaList(media);
      setActiveMedia(media[0] || null);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load product");
    } finally {
      setLoadingProduct(false);
    }
  };

  fetchProduct();
  window.scrollTo(0, 0);
}, [id, selectedDomain]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (mediaList.length > 0) {
      setActiveMedia(mediaList[0]);
    }
  }, [id, product]);
  
  if (loadingProduct) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      
      <p className="text-red-600 text-lg animate-pulse">Loading product...</p>
    </div>
  );
}

  if (!product) {
    return <div className="container my-5"><h2>Product not found!</h2></div>;
  }

  // Filter similar products
  const similarProducts = products.filter(p =>
    p.category === product.category && p.product_id !== product.product_id
  ).slice(0, 4);

  const isInWishlist = wishlist?.some(item => item.product_id === product.product_id) ?? false;
  // const subtotal = parseFloat(product.price);
  const inStock = product.in_stock === 1;

  // ------------------- Cart & Wishlist Functions -------------------
  const addToGuestCart = (product) => {
    const guestCart = JSON.parse(localStorage.getItem("cart") || "[]");
    const existing = guestCart.find(item => item.product_id === product.product_id);

    if (existing) {
      existing.quantity += 1;
    } else {
      guestCart.push({
        product_id: product.product_id,
        quantity: 1,
        price: product.price,
        inStock: product.in_stock,
        name: product.name,
        image_url: product.image_url
      });
    }
    localStorage.setItem("cart", JSON.stringify(guestCart));
    toast.success("Added to cart");
  };

  const addToUserCart = async (product) => {
  try {
    const res = await fetch(`${API}/api/cart/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      },
       body: JSON.stringify({
    product_id: product.product_id,
    quantity: 1,
    name: product.name,
    price: product.price,
    image: product.image_url,
    in_stock: product.in_stock,
    category: product.category
  })
    });
    const data = await res.json();
    toast.success(data.message || "Added to cart");

    const cartRes = await fetch(`${API}/api/cart`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
    });
    const cartData = await cartRes.json();
    setCart(cartData);
  } catch (err) {
    console.error("Error adding to cart:", err);
    toast.error("Failed to add to cart");
  }
};

  const handleAddToCart = async () => {
    isLoggedIn ? await addToUserCart(product) : addToGuestCart(product);
  };

  // const handleBuyNowClick = () => {
  //   const token = localStorage.getItem("token");

  // if (!checkAuth()) {
  //   if (token) {
  //     // User had logged in, but token expired
  //     toast.error("Session expired. Please login to continue.");
  //   } else {
  //     // New user / guest
  //     toast.error("Please login to buy the product.");
  //   }
  //   return navigate(`/auth?tab=register`);
  // }
  // const item = {
  //   id: product.product_id,
  //   name: product.name,
  //   price: Number(product.price),
  //   quantity: buyNowQuantity,
  //   image: product.image_url,
  //   inStock: product.in_stock
  // };

  //   setBuyNowItems([item]);       // Wrap in array to match modal structure
  //   setSubtotal(item.price * buyNowQuantity);
  //   setIsPurchaseModalOpen(true); // Open the modal
  // };
 const handleBuyNowClick = () => {
  if (!checkAuth()) {
    toast.error("Please login to buy the product.");
    return navigate(`/auth?tab=register`);
  }
  
  const item = {
    id: product.product_id,
    name: product.name,
    price: Number(product.price),
    quantity: buyNowQuantity,
    image: product.image_url,
    inStock: product.in_stock,
    product_type: selectedDomain
  };
  console.log(selectedDomain,product.price)

  setBuyNowItems([item]);
  setSubtotal(item.price * buyNowQuantity);
  setIsPurchaseModalOpen(true);
};

  const handleWishlistToggle = async () => {
  if (!checkAuth()) {
    toast.error("Session expired. Please login to continue");
    return navigate(`/auth?tab=register`);
  }

  const isInWishlist = wishlist.some(
    item => item.product_id === product.product_id
  );

  try {
    if (isInWishlist) {
      await handleRemoveFromWishlist(product.product_id);
      toast.success("Removed from wishlist");
    } else {
      await handleAddToWishlist(product); // ✅ directly use current product
      toast.success("Added to wishlist!");
    }
  } catch (err) {
    console.error(err);
    toast.error("Failed to update wishlist");
  }
};
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) stars.push(<StarFill key={i} className="w-5 h-5 text-yellow-500" />);
      else if (rating >= i - 0.5) stars.push(<StarHalf key={i} className="w-5 h-5 text-yellow-500" />);
      else stars.push(<Star key={i} className="w-5 h-5 text-gray-300" />);
    }
    return stars;
  };
  // const handleNotifyMe = async () => {
  //   if (!isLoggedIn) {
  //     toast.error("Please login to get notified when the product is back in stock.");
  //     return;
  //   }

  //   try {
      

  //     toast.success("You’ll be notified when this product is back in stock 💌");
  //   } catch (err) {
  //     toast.error("Failed to enable notifications");
  //   }
  // };
  const handleMouseMove = (e) => {
  if (!imageRef.current || !lensRef.current || !zoomRef.current) return;

  const rect = imageRef.current.getBoundingClientRect();

  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  const lensSize = 120;
  const zoomLevel = 2.5;

  let lensX = x - lensSize / 2;
  let lensY = y - lensSize / 2;

  // Boundaries
  lensX = Math.max(0, Math.min(lensX, rect.width - lensSize));
  lensY = Math.max(0, Math.min(lensY, rect.height - lensSize));

  // Move lens
  lensRef.current.style.left = `${lensX}px`;
  lensRef.current.style.top = `${lensY}px`;

  // Zoom
  zoomRef.current.style.backgroundImage = `url(${activeMedia?.src})`;
  zoomRef.current.style.backgroundSize = `${rect.width * zoomLevel}px ${rect.height * zoomLevel}px`;
  const maxX = rect.width * zoomLevel - zoomRef.current.offsetWidth;
const maxY = rect.height * zoomLevel - zoomRef.current.offsetHeight;

let bgX = lensX * zoomLevel;
let bgY = lensY * zoomLevel;

// Clamp values
bgX = Math.max(0, Math.min(bgX, maxX));
bgY = Math.max(0, Math.min(bgY, maxY));

zoomRef.current.style.backgroundPosition = `-${bgX}px -${bgY}px`;
console.log("Image:", activeMedia?.src);
console.log("Width:", imageRef.current?.naturalWidth);
console.log("Height:", imageRef.current?.naturalHeight);
};


  // ------------------- JSX -------------------
  return (
    <div className="w-full pt-4 sm:pt-10 pb-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-3 sm:px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">

          {/* LEFT COLUMN: Media Gallery & CTA */}
          <div className="flex flex-col gap-4 sm:gap-6 md:sticky md:top-20 md:self-start">

            {/* Gallery Wrapper */}
            <div className="flex flex-col-reverse sm:flex-row gap-3 sm:gap-4 h-auto sm:h-[400px] md:h-[500px]">

              {/* Thumbnails Strip */}
              <div className="flex sm:flex-col gap-2 sm:gap-3 overflow-x-auto sm:overflow-y-auto w-full sm:w-[80px] h-[60px] sm:h-full no-scrollbar">
                {mediaList.map((media, index) => (
                  <div
                    key={index}
                    onClick={() => setActiveMedia(media)}
                    className={`relative w-16 h-16 sm:w-20 sm:h-20 rounded-lg cursor-pointer overflow-hidden border-2 transition-all flex-shrink-0 ${activeMedia === media ? 'border-red-600 ring-1 ring-red-600' : 'border-gray-200 hover:border-gray-400'}`}
                  >
                    {media.type === 'video' ? (
                      <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                        <PlayCircleFill className="text-gray-600 w-5 h-5 sm:w-8 sm:h-8" />
                      </div>
                    ) : (
                      <img
                        src={media.src}
                        alt={`thumbnail-${index}`}
                        className={`w-full h-full object-cover ${media.filter === 'sepia' ? 'sepia' : ''}`}
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* Main Media Display */}
              <div className="relative flex-1 overflow-visible min-h-[280px] sm:min-h-full h-[250px] sm:h-[450px]">

  {activeMedia?.type === 'video' ? (
    <video
      controls
      autoPlay
      className="w-full h-full object-contain"
      poster={activeMedia.poster}
    >
      <source src={activeMedia.src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <>
      {/* IMAGE + LENS */}
      <div
        className="relative w-full h-full"
        onMouseEnter={() => {}}
onMouseMove={(e) => {
  setShowZoom(true);
  handleMouseMove(e);
}}
        onMouseLeave={() => setShowZoom(false)}
    
      >
        <img
          ref={imageRef}
          src={activeMedia?.src}
          alt={product.name}
          className={`w-full h-full object-contain select-none transition-opacity duration-300 ${
            activeMedia?.filter === 'sepia' ? 'sepia' : ''
          }`}
        />

        {/* 🔲 Lens */}
        {showZoom && (
          <div
            ref={lensRef}
            className="absolute border border-gray-400 bg-white/30 pointer-events-none"
            style={{
              width: "120px",
              height: "120px"
            }}
          />
        )}
      </div>

      {/* 🔍 Zoom Preview */}
      {showZoom && activeMedia?.src && (
  <div
    ref={zoomRef}
    className="hidden md:block absolute top-0 left-full ml-4 w-[600px] h-[470px] border bg-white shadow-lg z-50"
    style={{
      backgroundRepeat: "no-repeat"
    }}
  />
)}
    </>
  )}

  {/* ❤️ Wishlist Button */}
  <button
    onClick={e => {
      e.stopPropagation();
      handleWishlistToggle();
    }}
    className="absolute top-3 right-3 z-10 bg-white/80 p-2 rounded-full focus:outline-none hover:bg-white hover:scale-110 transition-all duration-200 shadow-sm"
  >
    {isInWishlist ? (
      <HeartFill className="w-6 h-6 text-red-600" />
    ) : (
      <Heart className="w-6 h-6 text-red-600" />
    )}
  </button>

</div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-2 sm:gap-3 w-full">

              {/* QUANTITY SELECTOR */}

              <div className="flex items-center gap-2 text-sm sm:text-base">
                <span className="font-semibold text-gray-700 whitespace-nowrap">Qty:</span>
                <select
                  value={!isCustomQuantity ? buyNowQuantity : 'more'}
                  onChange={(e) => {
                    if (e.target.value === 'more') {
                      setIsCustomQuantity(true);
                      setCustomInput('4');       // default string
                      setBuyNowQuantity(4);      // numeric
                    } else {
                      setIsCustomQuantity(false);
                      setBuyNowQuantity(Number(e.target.value));
                    }
                  }}
                  className="px-2 sm:px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 shadow-sm flex-1 sm:flex-none"
                >
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value="more">More...</option>
                </select>

                {isCustomQuantity && (
                  <input
                    type="number"
                    min={1}
                    value={customInput}
                    onChange={(e) => {
                      setCustomInput(e.target.value);           // keep string
                      if (e.target.value !== '') {
                        setBuyNowQuantity(Number(e.target.value));
                      }
                    }}
                    onBlur={() => {
                      if (!customInput || Number(customInput) <= 3) {
                        setIsCustomQuantity(false);
                      }
                    }}
                    className="w-20 px-2 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 shadow-sm"
                    autoFocus
                  />
                )}
              </div>


              {/* ADD TO CART */}
              <div className="flex flex-col md:flex-row gap-2 sm:gap-3 w-full">
  <button
    onClick={handleAddToCart}
    disabled={!inStock}
    className={`flex-1 flex items-center justify-center gap-1 sm:gap-2 rounded-xl text-white font-bold text-sm sm:text-base py-2.5 sm:py-3 transition-all duration-300
      ${inStock
        ? "bg-gradient-to-r from-red-500 to-red-700 hover:shadow-xl"
        : "bg-gray-400 cursor-not-allowed"
      }`}
  >
    <Cart size={18} className="sm:w-5.5 sm:h-5.5" />
    <span>Add to Cart</span>
  </button>

 <button
  onClick={handleBuyNowClick}
  disabled={!inStock}
  className={`flex-1 flex items-center justify-center gap-1 sm:gap-2 
  rounded-xl font-semibold text-white text-sm sm:text-base 
  py-2.5 sm:py-3 transition-all duration-300
  ${
    inStock
      ? "bg-black hover:bg-gray-900 shadow-md hover:shadow-xl active:scale-95"
      : "bg-gray-400 cursor-not-allowed"
  }`}
>
  <Lightning size={18} className="sm:w-5.5 sm:h-5.5 animate-pulse" />
  <span>Buy Now</span>
</button>
</div>
            </div>
          </div>
          {/* RIGHT COLUMN: Details */}
          <div className="px-0 sm:px-4">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 mt-4 md:mt-0">{product.name}</h1>
            <p className="text-gray-700 text-sm sm:text-base mb-2">{product.short_description}</p>
            <p className="text-xl sm:text-2xl font-bold text-red-600 mb-1">₹{product.price} <span className='text-xs sm:text-sm text-gray-500'>(Inclusive of all taxes)</span></p>
            <p className={`font-semibold text-base sm:text-lg mb-4 ${inStock ? "text-green-600" : "text-red-500"}`}>{inStock ? "✔ In Stock" : "✘ Out of Stock"}</p>

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 text-sm sm:text-base text-gray-600 mb-6">
              <span>🚚 Fast Delivery</span>
              <span>🔒 Secure Payments</span>
              <span>↩ Easy Returns</span>
            </div>

            <div className="product-highlights mb-6">
              <h3 className="text-lg sm:text-xl font-semibold mb-2">Product Benefits</h3>
              <p className='text-gray-700 text-sm sm:text-base space-y-1'>{product.highlights}</p>
            </div>
            
            <h2 className="text-lg sm:text-xl font-semibold mb-2">About the Product</h2>
            <p className="text-gray-700 text-sm sm:text-base space-y-1 mb-6">{product.full_description}</p>

            {/* <h2 className="text-lg sm:text-xl font-semibold mb-2">Rating & Reviews</h2> */}
            {/* <div className="flex items-center gap-2">
              <p className="flex gap-1">{renderStars(product.rating)}</p>
              <span className="text-sm sm:text-base font-medium text-gray-700">{product.rating}</span>
              <span className="text-xs sm:text-sm text-gray-500">({product.reviews} ratings)</span>
            </div> */}
          </div>
        </div>

        {/* --- SIMILAR PRODUCTS SECTION --- */}
        {similarProducts.length > 0 && (
          <div className="mt-16 px-4 md:px-16 border-t border-gray-200 pt-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Similar Products</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {similarProducts.map((p) => (
                <div
                  key={p.product_id}
                  className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden cursor-pointer border border-gray-100"
                  onClick={() => navigate(`/product/${p.product_id}`)}
                >
                  <div className="h-48 w-full p-4 bg-gray-50">
                    <img
                      src={`${API}${p.image_url}`}
                      alt={p.name}
                      className="w-full h-full object-contain hover:scale-105 transition-transform"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="font-semibold text-gray-800 truncate">{p.name}</h3>
                    <p className="text-red-600 font-bold mt-1">₹{p.price}</p>
                    <div className="flex items-center mt-2">
                      <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                        {p.short_description}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {isPurchaseModalOpen && (
  <PurchaseModal
    user={user}
    items={buyNowItems}
    subtotal={subtotal}
    checkoutType="single"
    onClose={() => setIsPurchaseModalOpen(false)}
    
  />
)}

    </div>

  );
};

export default ProductDetailsPage;